export default "__VITE_ASSET__Bbneu_9T__"